import NavbarComp from './NavbarComp';
export default NavbarComp;